import { AdaptorTypes, ConfigLayer } from '@Map/types';
import { Info360TileMetadataV2 } from '@Map/services/Info360TileTypes';
import ExternalConfigAdaptor from './ExternalConfigAdaptor';
import { TileJson } from '@Map/services/types';

/**
 * AmSpatialConfigAdaptor - Extracts amSpatial system from V3 response and creates layer config
 */
export default class AmSpatialConfigAdaptor extends ExternalConfigAdaptor {
	static _type: AdaptorTypes = AdaptorTypes.amSpatial;
	static _endpointPathname = '/v3/tileset-index';

	/**
	 * Convert amSpatial data from V3 tileset to layer configuration
	 * @param data Info360TileMetadataV2 response (full V3 response)
	 * @returns partial configuration object for amSpatial layers
	 */
	converter = (data: Info360TileMetadataV2): Partial<ConfigLayer> => {
		// Extract amSpatial from the systems
		const amSpatialData = data.systems?.['amSpatial'];

		if (!amSpatialData || Array.isArray(amSpatialData)) {
			return {};
		}

		const tileJson = amSpatialData as TileJson;

		// Create layers from vector_layers
		const layers: ConfigLayer['layers'] = tileJson.vector_layers.map(
			layer => ({
				layerName: layer.description || layer.id,
				id: layer.id,
				tileLayerName: layer.id,
				type: this._getLayerType(layer.geometry),
				minZoom: layer.minzoom,
			}),
		);

		return { layers };
	};

	/**
	 * Map geometry type to layer type
	 */
	private _getLayerType(
		geometry: string,
	): 'symbol' | 'line' | 'polygon' | 'fill' {
		const lowerGeometry = geometry.toLowerCase();
		if (lowerGeometry.includes('point')) {
			return 'symbol';
		} else if (lowerGeometry.includes('line')) {
			return 'line';
		} else if (lowerGeometry.includes('polygon')) {
			return 'fill';
		}
		return 'symbol'; // default
	}
}

export const amSpatialConfigCreatorV3 = AmSpatialConfigAdaptor.creator.bind(
	AmSpatialConfigAdaptor,
);
